let getStoryage = (item) => {
  let str = sessionStorage.getItem(item)
  return JSON.parse(str)
}
const getters = {
  get_currency: (state) => {
    return state.currency ? state.currency : getStoryage('currency')
  },
  get_balancePay: (state) => {
    return state.balancePay ? state.balancePay : sessionStorage.getItem('balancePay')
  }
}
export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js